import React, { useState, createRef, useEffect } from 'react';
import HeaderBar from './components/Header/Header.js';
import Banner from './components/Banner/Banner.js';
import Banner2 from './components/Banner2/Banner2.js';
import Banner3 from './components/Banner3/Banner3.js';
import Banner4 from './components/Banner4/Banner4.js';
import Banner5 from './components/Banner5/Banner5.js';
import Banner6 from './components/Banner6/Banner6.js';
import FAQ from './components/FAQ/FAQ.js';
import ContactUs from './components/ContactUs/ContactUs.js';
import ContactUsPage from './components/ContactUsPage/ContactUsPage.js';
import './App.css';

const App = () => {
  const [showContactUsPage, setShowContactUsPage] = useState(false);
  const [scrollTarget, setScrollTarget] = useState(null);
  const faqRef = createRef();
  const specRef = createRef();
  const learnRef = createRef();

  useEffect(() => {
    if (scrollTarget && !showContactUsPage) {
      setTimeout(() => {
        scrollTarget();
        setScrollTarget(null);
      }, 1000);
    }
  }, [showContactUsPage, scrollTarget]);

  const scrollToAboutUs = () => {
    if (faqRef.current) {
      faqRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToSpec = () => {
    if (specRef.current) {
      specRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToLearn = () => {
    if (learnRef.current) {
      learnRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleContactUsClick = () => {
    setShowContactUsPage(true);
  };

  const handleOtherClicks = (scrollFunction) => {
    if (showContactUsPage) {
      setShowContactUsPage(false);
      setScrollTarget(() => scrollFunction);
    } else {
      scrollFunction();
    }
  };

  const handleLogoClick = () => {
    setShowContactUsPage(false);
    setScrollTarget(null);
  };

  return (
    <div className="body">
      <HeaderBar 
        AboutUsClicked={() => handleOtherClicks(scrollToAboutUs)}
        SpecClicked={() => handleOtherClicks(scrollToSpec)}
        LearnClicked={() => handleOtherClicks(scrollToLearn)}
        ContactUsClicked={handleContactUsClick}
        isContactPage={showContactUsPage}
        onLogoClick={handleLogoClick}
      />
      {showContactUsPage ? (
        <ContactUsPage />
      ) : (
        <div>
          <Banner LearnClicked={() => handleOtherClicks(scrollToLearn)} />
          <Banner2 ref={faqRef} />
          <Banner3 ref={learnRef} />
          <Banner4 ref={specRef} />
          <Banner5 />
          <Banner6 />
          <FAQ />
          <ContactUs />
        </div>
      )}
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js